import CommonGetters from '@/utils/CommonGetters.js';
import StateUtils from '@/utils/StateUtils.js';
import CustomDecimals from '@/utils/CustomDecimals.js';

const STORAGE_KEY = 'pandora-creator-autosave';

export function checkAutosave (savedState = null) {
  let item = savedState;
  if (!savedState) {
    item = localStorage.getItem(STORAGE_KEY);
  }
  if (!item) {
    return null;
  }

  try {
    const parsedData = JSON.parse(item);
    let outputData = { wardrobeList: [] };

    // fallback for projects saved before
    if (!Object.hasOwn(parsedData, 'wardrobeList') && Object.hasOwn(parsedData, 'inventory') && Object.hasOwn(parsedData, 'wardrobe')) {
      // Old configuration had only one wardrobe
      let objectToSave = { ...parsedData };
      let hasDoor = parsedData.hasDoorOnly || parsedData.hasFullWardrobe;
      let hasInventory = parsedData.hasInventoryOnly || parsedData.hasFullWardrobe;
      objectToSave.creatorMode = {
        hasDoor,
        hasInventory,
      }

      delete objectToSave.hasDoorOnly;
      delete objectToSave.hasFullWardrobe;
      delete objectToSave.hasInventoryOnly;

      if (!objectToSave.id) {
        objectToSave.id = CustomDecimals.generateUUID();
      }
      outputData.wardrobeList = [objectToSave];
    } else {
      outputData.wardrobeList = parsedData.wardrobeList;
    }

    const hasWardrobes = outputData.wardrobeList && outputData.wardrobeList.length > 0;
    let canLoadData = false;
    if (hasWardrobes && outputData.wardrobeList[0].wardrobe && outputData.wardrobeList[0].wardrobe.width) {
      canLoadData = true;

      outputData.wardrobeList.forEach(wardrobeItem => {
        wardrobeItem.price = StateUtils.getDefaultWardrobePriceObject();
        wardrobeItem.isFromAutoSave = true;

        // reset steps to force wardrobe check
        wardrobeItem.stepsCompletion.wardrobeDimensions = false;
        wardrobeItem.stepsCompletion.wardrobeDoorsDivision = false;
        wardrobeItem.stepsCompletion.wardrobeDoorsMaterial = false;
        wardrobeItem.stepsCompletion.wardrobeDoorsNumber = false;
        wardrobeItem.stepsCompletion.wardrobeInventory = false;
        wardrobeItem.stepsCompletion.wardrobePosition = false;
      });
    }

    let savedOn = null;
    if (parsedData.timestamp) {
      savedOn = CommonGetters.formatDateTimeForDisplay(new Date(parsedData.timestamp));
    }

    if (canLoadData) {
      return {
        isValid: true,
        date: savedOn,
        wardrobeCount: outputData.wardrobeList.length,
        data: outputData
      };
    }

    return null;
  } catch (e) {
    console.error('Uszkodzony plik zapisu', e);
    return null;
  }
}

export function clearAutosave () {
  localStorage.removeItem(STORAGE_KEY);
}
